import { moment } from "../date";
import type { Tables } from "../types";

type Employment = Tables<"employments">;

export function getActiveEmployment(employments: Employment[]): Employment | undefined {
	if (employments.length === 0) return undefined;

	const active = employments.find((e) => {
		if (e.validTo === null) return true;
		return (
			moment(e.validFrom).isSameOrBefore(moment(), "day") &&
			moment(e.validTo).isSameOrAfter(moment(), "day")
		);
	});

	if (active) return active;

	return employments.reduce((latest, e) => {
		if (!latest.validTo) return latest;
		if (!e.validTo) return e;
		return e.validTo > latest.validTo ? e : latest;
	});
}
